import React from 'react';

interface LogoCardProps {
  logo: React.ReactNode;
  alt?: string;
  className?: string;
}

const LogoCard = ({ 
  logo, 
  alt = "Logo", 
  className = "" 
}: LogoCardProps) => {
  return (
    <div 
      className={`flex items-center justify-center ${className}`}
      style={{
        width: '11.875rem',
        height: '11.625rem',
        flexShrink: 0,
        borderRadius: '2rem',
        background: '#FFF',
        boxShadow: '0px 23px 7px 0px rgba(0, 0, 0, 0.00), 0px 15px 6px 0px rgba(0, 0, 0, 0.01), 0px 8px 5px 0px rgba(0, 0, 0, 0.05), 0px 4px 4px 0px rgba(0, 0, 0, 0.09), 0px 1px 2px 0px rgba(0, 0, 0, 0.10)'
      }}
    >
      <div className="w-20 h-20 flex items-center justify-center">
        {typeof logo === 'string' ? (
          <img src={logo} alt={alt} className="w-full h-full object-contain" />
        ) : (
          logo
        )}
      </div>
    </div>
  );
};

export default LogoCard; 